import { Box, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import { darkTheme } from "@avenue-8/sidekick-ui";

export const TimelineDot = styled(Box)`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.text.colors.brand};
  flex-shrink: 0;
`;

export const CodeBlockWrapper = styled(Box)`
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  padding-top: 1rem;
  background-color: ${(p) => p.theme.jsonText.colors.background};

  pre {
    margin: 0;
  }
`;

export const CopyIconButton = styled(IconButton)`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  color: ${darkTheme.button.text.colors.text};

  &:hover,
  &:active,
  &:focus {
    color: ${darkTheme.button.text.hover.text};
    background-color: ${darkTheme.button.text.hover.background};
  }

  svg {
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }
`;
